<template>
  <div data-cy="paciente-card-container">
    <div data-cy="paciente-card-actions">
      <font-awesome-icon
        class="acao-card-edicao"
        icon="edit"
        v-b-modal="`modaledit-${paciente.id}`"
        data-cy="btn-paciente-editar"
      ></font-awesome-icon>
      <font-awesome-icon
        class="acao-card-remocao"
        v-if="paciente.dependente"
        icon="times"
        v-b-modal="`modal-${paciente.id}`"
        data-cy="btn-paciente-remover"
      ></font-awesome-icon>
    </div>
    <div class="text-primary" data-cy="paciente-card-content">
      <div
        v-if="paciente.deleted"
        class="w-100 h-100 d-flex justify-content-center p-3"
        style="position: absolute; z-index: 9999; background-color: rgba(255,255,255,0.7)"
        data-cy="paciente-card-loading"
      >
        <b-spinner
          variant="info"
          class="mt-3"
          label="Spinning"
          center
          data-cy="paciente-card-spinner"
        ></b-spinner>
      </div>

      <div
        :class="
          `custom-radio-wrapper ${
            paciente_s && paciente_s.id === paciente.id ? 'border-primary' : ''
          }`
        "
        @click="submit"
        data-cy="paciente-card-radio-wrapper"
      >
        <div class="custom-control custom-radio" data-cy="paciente-card-radio">
          <input
            type="radio"
            :id="`customRadio-${paciente.id}`"
            :name="`customRadio-${paciente.id}`"
            class="custom-control-input"
            :checked="paciente_s && paciente_s.id === paciente.id"
            data-cy="paciente-card-radio-input"
          />
          <label
            class="custom-control-label d-flex align-items-center justify-content-center"
            for="customRadio1"
            data-cy="paciente-card-radio-label"
          >
            <font-awesome-icon
              size="4x"
              :icon="['far', 'user']"
              class="pr-3"
              data-cy="icon-paciente-avatar"
            ></font-awesome-icon>
            <!-- img src="/static/images/avatar.png" class="rounded-circle pr-3" height="64" -->
            <span
              class="d-inline-flex flex-column"
              for="customRadio2"
              data-cy="paciente-card-info"
            >
              <span class="text-primary" data-cy="paciente-card-nome">
                {{ paciente.nome }}
              </span>
              <span class="small text-muted" data-cy="paciente-card-tipo">{{
                paciente.dependente
                  ? user.vendedorConsultas
                    ? "Paciente"
                    : "Dependente"
                  : user.vendedorConsultas
                  ? "Prospector"
                  : "Titular"
              }}</span>
            </span>
          </label>
        </div>
      </div>
      <b-modal
        style="z-index: 9999"
        @ok="removePaciente"
        class="text-black"
        :id="`modal-${paciente.id}`"
        centered
        data-cy="modal-paciente-remover"
      >
        <h6 data-cy="modal-paciente-remover-titulo">
          Tem certeza que deseja remover {{ paciente.name }} de sua lista de
          dependentes?
        </h6>
      </b-modal>

      <paciente-edit
        :patient="paciente"
        :titular="!paciente.dependente"
        data-cy="paciente-edit-component"
      ></paciente-edit>
    </div>
  </div>
</template>

<script>
import PacienteEdit from "@/components/paciente-edit.vue";
import { generateTo } from "@/core/routerHelper.js";

export default {
  name: "paciente-card",
  props: ["paciente"],
  components: {
    PacienteEdit
  },
  computed: {
    paciente_s() {
      return this.$store.getters.get_selected[5];
    },
    user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    submit() {
      this.paciente.stepId = 6;
      this.$store.dispatch("load_selected", this.paciente);
      this.$store.dispatch("set_to", {
        name: generateTo(7, this.$route),
        params: {
          organizationId: this.$route.params.organizationId
        },
        query: {
          ...(localStorage.getItem("telemedicina")
            ? { telemedicina: localStorage.getItem("telemedicina") }
            : {})
        }
      });

      this.$router.push(this.$store.getters.to);
    },
    removePaciente() {
      let payload = {
        url: this.$serverHost,
        patient: this.paciente
      };
      this.$store.dispatch("remove_patient", payload);
    }
  }
};
</script>

<style></style>
